@if (book()) {
  <app-book [book]="book()!" />
} @else {
  <app-book-missing></app-book-missing>
}
